import Product from '../api/product';
import * as mutation from '../mutations/product';

const state = {
  products_max_page: 2,
  products_total_count: 0,
  products: [],
  product: {
    channel_idx: 0,
    channels: { idx: 0, title: '', subscribes: false, subscribe_cnt: 0 },
    idx: 0,
    created_at: 0,
    updated_at: 0,
    published_at: 0, // 얼리버드 결제시, 결제 시점과 강의 시작 시점이 다르기 때문에 필요
    thumbnail: '',
    subtitle: '', // '얼리버드 할인중', '오픈기념 할인중', '바로 수강 가능'
    title: '',
    discount: 0, // unit: %
    amount: 0, // unit: KRW
    installment: 1, // 디스플레이용 할부 기간
    review_avg: 0, // 별점 평균
    summary: '', // 요약 설명문
    contents: '',
    image_list: [],
    // hashtag: [],
    talk_cnt: 0,
    view_cnt: 0,
    share_cnt: 0,
    like_cnt: 0,
    likes: false,
    bookmark_cnt: 0,
    bookmarks: false,
    status: '', // 'ready', 'for-sale', 'early-bird', 'close'
    // locale: '',
    // privacy: 'public',
    category_idx: 1, // 스토어, 컨설팅 구분
    subcategory_idx: 1, // 상품 목록 탭 아이템 구분
    alarms: false,
    packages: false,
    package_contents: '',
    purchases: false, // 구매했는지 여부
    chapters: [],
    review_cnt: 1,
    reviews: [],
    talks: [],
    recommends: [], // 연관 스토리
    time_deadline: '', // 타임어택 종료시간
    time_invalids: [] // 상담신청 불가날짜
  },
  reviews_max_page: 2,
  talks_max_page: 2,
  purchaseOption: {
    packages: [],
  },
  purchases_max_page: 2,
  purchases: [],
};

const getters = {
  products_max_page: state => state.products_max_page,
  products: state => state.products,
  product: state => state.product,
  packages: state => state.purchaseOption.packages,
  talks: state => state.product.talks,
  reviews: state => state.product.reviews,
  purchases: state => state.purchases,
};

const actions = {
  selectStorePre (context, { nationIdx, tourIdx, categoryIdx, type, second }) { // 스토어 최초 얼리버드, 신규예정 로드
    return Product.getStorePre(tourIdx, nationIdx, categoryIdx, type, second);
  },
  selectProducts (context, { status, nationIdx, tourIdx, categoryIdx, type, page, second, hashtag }) { // status: forsale, earlybird, ready
    return Product.getStoreProgress(status, tourIdx, nationIdx, categoryIdx, type, page, second, hashtag);
  },
  selectProduct ({ commit }, idx) { // 상품 상세
    return Product.getProduct(idx).then(response => {
      commit(mutation.SELECT_PRODUCT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  toggleBookmark (context, idx) { // 상품 찜
    return Product.postStoreIdxBookmark(idx);
  },
  toggleAlarm (context, idx) { // 신규예정 상품 알람신청
    return Product.postStoreIdxAlarm(idx);
  },
  createTalk ({ commit }, { idx, content }) { // 렛츠톡 작성
    return Product.postStoreIdxTalk(idx,content).then(response => {
      commit(mutation.CREATE_TALK, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  createComment ({ commit }, { storeIdx, talkIdx, content }) { // 톡 댓글 작성
    return Product.postStoreIdxTalkIdxComment(storeIdx, talkIdx, content).then(response => {
      commit(mutation.CREATE_COMMENT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  toggleLikeTalk ({ commit }, { storeIdx, talkIdx }) { // 톡 좋아요
    return Product.postStoreIdxTalkIdxLike(storeIdx, talkIdx).then(response => {
      commit(mutation.TOGGLE_LIKE_TALK, { storeIdx, talkIdx, flag: response.data });
    }).catch(err => {
      console.error(err);
    });
  },
  toggleLikeComment ({ commit }, { storeIdx, talkIdx, commentIdx }) { // 톡 댓글 좋아요
    return Product.postStoreIdxTalkIdxCommentIdxLike(storeIdx, talkIdx, commentIdx).then(response => {
      commit(mutation.TOGGLE_LIKE_COMMENT, { talkIdx, commentIdx, flag: response.data });
    }).catch(err => {
      console.error(err);
    });
  },
  reportTalk (context, { storeIdx, talkIdx }) { // 톡 신고
    return Product.postStoreIdxTalkIdxReport(storeIdx, talkIdx);
  },
  reportComment (context, { storeIdx, talkIdx, commentIdx }) { // 톡 댓글 신고
    return Product.postStoreIdxTalkIdxCommentIdxReport(storeIdx, talkIdx, commentIdx);
  },
  deleteTalk ({ commit }, { storeIdx, talkIdx }) { // 톡 삭제
    return Product.deleteStoreIdxTalkIdx(storeIdx, talkIdx).then(response => {
      if (response.data) commit(mutation.DELETE_TALK, { storeIdx, talkIdx });
    }).catch(err => {
      console.error(err);
    });
  },
  deleteComment ({ commit }, { storeIdx, talkIdx, commentIdx }) { // 톡 댓글 삭제
    return Product.deleteStoreIdxTalkIdxCommentIdx(storeIdx, talkIdx, commentIdx).then(response => {
      if (response.data) commit(mutation.DELETE_COMMENT, { talkIdx, commentIdx });
    }).catch(err => {
      console.error(err);
    })
  },
  selectPackages ({ commit }, idx) {
    return Product.getStoreIdxPackage(idx).then(response => {
      commit(mutation.SELECT_PACKAGES, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  selectTalks ({ commit }, { second, idx, page }) {
    if (page <= state.talks_max_page) {
      return Product.getStoreIdxTalk(second, idx, page).then(response => {
        commit(mutation.SELECT_TALKS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectComments ({ commit }, { second, storeIdx, talkIdx, offset }) {
    return Product.getStoreIdxTalkIdxComment(second, storeIdx, talkIdx, offset).then(response => {
      commit(mutation.SELECT_COMMENTS, { talkIdx, response });
    }).catch(err => {
      console.error(err);
    });
  },
  selectReviews ({ commit }, { second, idx, page }) {
    if (page <= state.reviews_max_page) {
      return Product.getStoreIdxReview(second, idx, page).then(response => {
        commit(mutation.SELECT_REVIEWS, response);
      }).catch(err => {
        console.error(err);
      })
    }
  },
  selectPurchases ({ commit }, { second, page }) {
    if (page <= state.purchases_max_page) {
      return Product.getStorePayment(second, page).then(response => {
        commit(mutation.SELECT_PURCHASES, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  requestPaymentCancel (context, { idx, cancelType, cancelMessage }) { // 구매 취소 요청 (to slack)
    return Product.postPaymentCancel(idx, cancelType, cancelMessage);
  },
  selectReview (context, { storeIdx, reviewIdx }) {
    return Product.getStoreIdxReviewIdx(storeIdx, reviewIdx);
  },
  createOrUpdateReview (context, { storeIdx, contents, reviewScore }) {
    return Product.postStoreIdxReview(storeIdx, contents, reviewScore);
  },
  purchaseFreeProduct (context, { userIdx, storeIdx }) { // 무료 상품 구매목록에 추가
    return Product.postStorePayment(userIdx, storeIdx);
  },
  selectCoupons (context, page) { // 쿠폰 목록 조회
    return Product.getPaymentCoupon(page);
  },
  enrollCoupon (context, code) { // 쿠폰 코드로 등록
    return Product.postPaymentCoupon(code);
  },
  createConsultingForm (context, { storeIdx, type, location, name, phone, birthday, channel, interestNation, studyPeriod, studyStartDate, question, schedule }) {
    return Product.postStoreSurvey(storeIdx, type, location, name, phone, birthday, channel, interestNation, studyPeriod, studyStartDate, question, schedule);
  }
};

const mutations = {
  [mutation.SELECT_PRODUCTS] (state, response) {
    state.products_max_page = response.max_page;
    state.products_total_count = response.total_count;
    response.req_page === 1 ? state.products = response.data : state.products.push(...response.data);
  },
  [mutation.SELECT_PRODUCT] (state, product) {
    state.product = product;
  },
  [mutation.TOGGLE_SUBSCRIPTION] (state, { idx, flag }) {
    if (state.product.channels.idx === idx) {
      state.product.channels.subscribes = flag;
      flag ? state.product.channels.subscribe_cnt++ : state.product.channels.subscribe_cnt--;
    }
  },
  [mutation.TOGGLE_BOOKMARK] (state, { idx, flag }) { // 상품 찜
    if (state.products.length) {
      let target = state.products.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.bookmarks = flag;
        flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
      }
    }
    if (state.product.recommends.length) {
      let target2 = state.product.recommends.find(el => {
        return el.idx === idx;
      });
      if (typeof target2 !== 'undefined') {
        target2.bookmarks = flag;
        flag ? target2.bookmark_cnt++ : target2.bookmark_cnt--;
      }
    }
    if (state.product.idx === idx) {
      state.product.bookmarks = flag;
      flag ? state.product.bookmark_cnt++ : state.product.bookmark_cnt--;
    }
  },
  [mutation.CREATE_TALK] (state, talk) {
    if (state.product.idx === talk.store_idx) {
      talk.comments = [];
      talk.comment_cnt = 0;
      state.product.talk_cnt++;
      state.product.talks.unshift(talk);
    }
  },
  [mutation.CREATE_COMMENT] (state, comment) {
    let target = state.product.talks.find(el => {
      return el.idx === comment.talk_idx;
    });
    if (typeof target !== 'undefined') {
      state.product.talk_cnt++;
      target.comment_cnt++;
      target.comments.unshift(comment);
    }
  },
  [mutation.TOGGLE_LIKE_TALK] (state, { storeIdx, talkIdx, flag }) {
    if (state.product.idx === storeIdx) {
      let target = state.product.talks.find(el => {
        return el.idx === talkIdx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    }
  },
  [mutation.TOGGLE_LIKE_COMMENT] (state, { talkIdx, commentIdx, flag }) {
    let parent = state.product.talks.find(el => {
      return el.idx === talkIdx;
    });
    if (typeof parent !== 'undefined') {
      let target = parent.comments.find(el => {
        return el.idx === commentIdx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    }
  },
  [mutation.DELETE_TALK] (state, { storeIdx, talkIdx }) {
    if (state.product.idx === storeIdx) {
      let targetIndex = state.product.talks.findIndex(el => {
        return el.idx === talkIdx;
      });
      if (targetIndex > -1) {
        state.product.talks.splice(targetIndex, 1);
        state.product.talk_cnt--;
      }
    }
  },
  [mutation.DELETE_COMMENT] (state, { talkIdx, commentIdx }) {
    let parent = state.product.talks.find(el => {
      return el.idx === talkIdx;
    });
    if (typeof parent !== 'undefined') {
      let targetIndex = parent.comments.findIndex(el => {
        return el.idx === commentIdx;
      });
      if (targetIndex > -1) {
        parent.comments.splice(targetIndex, 1);
        parent.comment_cnt--;
        state.product.talk_cnt--;
      }
    }
  },
  [mutation.SELECT_PACKAGES] (state, packages) {
    state.purchaseOption.packages = packages;
  },
  [mutation.SELECT_TALKS] (state, response) {
    state.talks_max_page = response.max_page;
    if (response.req_page === 1) state.product.talks = response.data;
    else state.product.talks.push(...response.data);
  },
  [mutation.SELECT_COMMENTS] (state, { talkIdx, response }) {
    let target = state.product.talks.find(el => {
      return el.idx === talkIdx;
    });
    if (typeof target !== 'undefined') {
      target.comments.push(...response.data);
    }
  },
  [mutation.SELECT_REVIEWS] (state, response) {
    state.reviews_max_page = response.max_page;
    if (response.req_page === 1) state.product.reviews = response.data;
    else state.product.reviews.push(...response.data);
  },
  [mutation.SELECT_PURCHASES] (state, response) {
    state.purchases_max_page = response.max_page;
    response.data.forEach((purchase) => {
      if (purchase.payment.amount === null) purchase.payment.amount = 0;
      else purchase.payment.amount = parseInt(purchase.payment.amount);
    });
    if (response.req_page === 1) state.purchases = response.data;
    else state.purchases.push(...response.data);
  },
  [mutation.TOGGLE_ALARM] (state, flag) {
    state.product.alarms = flag;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
